import ProjectTemplate from '../../components/common/ProjectTemplate';
import PulleyEditorFormContainer from '../../components/conveyor-pulley/PulleyEditorFormContainer';
import PulleyWriteActionButtonsContainer from '../../components/conveyor-pulley/PulleyWriteActionButtonsContainer';

const PulleyWritePage = () => {
    return (
        <ProjectTemplate>
            <PulleyEditorFormContainer />
            <PulleyWriteActionButtonsContainer />
        </ProjectTemplate>
    );
};

export default PulleyWritePage;
